"use client";

import { ProductType } from "@/types/Products";
import {
  getComingSoonProducts,
  getNewProducts,
} from "@/utils/groupProductsByCategory";
import SliderCards from "../SliderCards";

type MediaCardsProps = {
  products: ProductType[];
  isNew?: boolean;
  isComingSoon?: boolean;
  link?: string;
};

const MediaCards = ({
  products,
  isNew,
  isComingSoon,
  link,
}: MediaCardsProps) => {
  const newProducts = getNewProducts(products || []);
  const comingSoonProducts = getComingSoonProducts(products || []);

  const mediaProducts = () => {
    if (isNew) {
      return newProducts;
    }
    if (isComingSoon) {
      return comingSoonProducts;
    }
  };

  const renderProducts = mediaProducts();

  const renderTitle = () => {
    if (isNew) {
      return "Новое за 7 дней";
    }
    if (isComingSoon) {
      return "Ожидается в блийжайшие 30 дней";
    }
  };

  const renderID = () => {
    if (isNew) {
      return "new";
    }
    if (isComingSoon) {
      return "category_soon";
    }
  };
  return (
    <>
      {renderProducts && renderProducts?.length > 0 ? (
        <div id={renderID()}>
          <SliderCards
            section={{
              content: {
                title: renderTitle() || "",
                cards: renderProducts || [],
                perSlides: 5,
                link: link,
              },
            }}
          />
        </div>
      ) : null}
    </>
  );
};

export default MediaCards;
